import tw from "twin.macro";

export const Wrapper = tw.div`h-[9.5rem] p-16 bg-shade-5 border border-shade-5 rounded-12`;
export const Flex = tw.div`flex gap-16`;
export const VerticalFlex = tw.div`flex flex-col justify-center `;
export const SocialsWrapper = tw.div`flex gap-8 pt-4`;
